/**
 * 📌 API 端點定義
 * 定義應用程式的 API 路徑，提供前端統一管理所有 API 路徑，確保可維護性。
 * @module ApiEndpoints
 */


/** ================================
 * 📌 登入/登出
 *  ================================
 */
export const POST_AUTH_LOGIN_API = `/api/login/`;
export const GET_AUTH_LOGOUT_API = `/api/logout/`;

/** ================================
 * 📌 遮罩API與紀錄
 *  ================================
 */
export const POST_SECURITY_MASK_API  = `/api/security-mask/`;
export const GET_SECURITY_EXPORT_API = `/api/security-export`;

/** ================================
 * 📌 Auth
 *  ================================
 */
export const GET_ME_CHECK_API = `/api/me/check/`;
export const GET_ME_API       = `/api/me/`;

/** ================================
 * 📌 AppSystem 系統
 *  ================================
 */
export const GET_SYSTEM_BUILD_TIME_API  = `/api/system/build-time/`;
export const GET_SYSTEM_TAIPEI_TIME_API = `/api/system/taipei-time/`;

/** ================================
 * 📌 ClubPermission 店舖權限
 *  ================================
 */
export const GET_CLUB_PERMISSIONS_OPTIONS_API = `/api/club-permissions/options/`;
export const GET_CLUB_PERMISSIONS_API         = `/api/club-permissions/`;
export const PUT_CLUB_PERMISSIONS_API         = GET_CLUB_PERMISSIONS_API;

/** ================================
 * 📌 ClubRemittance 店舖匯款
 *  ================================
 */
export const GET_REMITTANCE_LIST_API            = `/api/remittances/`;
export const GET_REMITTANCE_OPTIONS_API         = `/api/remittances/options/`;
export const POST_REMITTANCE_BY_CLUB_API        = `/api/remittances/by-club/`;
export const POST_REMITTANCE_BY_HEADQUARTER_API = `/api/remittances/by-headquarter/`;
export const DELETE_REMITTANCE_ID_API           = (remittanceID) => `/api/remittances/${remittanceID}/`;

/** ================================
 * 📌 ClubRemittanceReturn 店舖匯款折讓
 *  ================================
 */
export const GET_REMITTANCE_ALLOWANCE_ID_API               = (orderID) => `/api/remittance/${orderID}/allowance-dialog/`;
export const POST_REMITTANCE_ALLOWANCE_CONFIRM_API         = `/api/remittance/allowance-confirm/`;
export const GET_REMITTANCE_INVALID_ABANDON_ID_API         = (orderID) => `/api/remittance/${orderID}/invalid-dialog/`;
export const POST_REMITTANCE_INVALID_ABANDON_CONFIRM_API   = `/api/remittance/invalid-confirm/`;
export const GET_REMITTANCE_ABANDON_ALLOWANCE_ID_API       = (orderID) => `/api/remittance/${orderID}/allowance-history/`;
export const POST_REMITTANCE_ABANDON_ALLOWANCE_CONFIRM_API = `/api/remittance/invalid-allowance-confirm/`;

/** ================================
 * 📌 CustomerContactRecord 顧客聯繫相關
 *  ================================
 */
export const GET_CUSTOMERS_CONTACT_RECORDS_OPTIONS_API               = '/api/customers/contact-records/options/';
export const GET_CUSTOMERS_CUSTOMERID_CONTACT_RECORDS_API            = (customerID) => `/api/customers/${customerID}/contact-records/`;
export const GET_CUSTOMERS_CUSTOMERID_CONTACT_RECORDS_LAST5_API      = (customerID) => `/api/customers/${customerID}/contact-records/last5/`;
export const POST_CUSTOMERS_CUSTOMERID_CONTACT_RECORDS_API           = GET_CUSTOMERS_CUSTOMERID_CONTACT_RECORDS_API;
export const PUT_CUSTOMERS_CUSTOMERSID_CONTACT_RECORDS_CONTACTID_API = (customerID, contactID) => `/api/customers/${customerID}/contact-records/${contactID}/`;
export const DELETE_CUSTOMERS_CUSTOMERSID_CONTACT_RECORDS_API        = PUT_CUSTOMERS_CUSTOMERSID_CONTACT_RECORDS_CONTACTID_API;

/** ================================
 * 📌 Customer 顧客總覽/詢問新增、編輯/刪除
 *  ================================
 */
export const GET_CUSTOMERS_OVERVIEW_OPTIONS_API = `/api/customers/overview/options/`;
export const GET_CUSTOMERS_OVERVIEW_API         = `/api/customers/overview/`;
export const GET_CUSTOMERS_CUSTOMERID_API       = (customerID) => `/api/customers/${customerID}/`;
export const PUT_CUSTOMERS_CUSTOMERID_API       = GET_CUSTOMERS_CUSTOMERID_API;
export const POST_CUSTOMERS_API                 = '/api/customers/';
export const DELETE_CUSTOMERS_API               = POST_CUSTOMERS_API;
export const PUT_CUSTOMERS_JOIN_INVALID_API     = '/api/customers/join-invalid/';

/** ================================
 * 📌 Prospect 名單總覽/詢問新增、編輯/刪除
 *  ================================
 */
export const GET_GUESTS_OVERVIEW_API               = `/api/guests/overview/`;
export const GET_TEMPORARIES_OVERVIEW_API          = `/api/temporaries/overview/`;
export const POST_TEMPORARIES_OVERVIEW_OPTIONS_API = `/api/temporaries/overview/options/`;

/** ================================
 * 📌 CustomerGuest 名單建立
 *  ================================
 */
export const GET_GUEST_OVERVIEW_OPTIONS_API = `/api/guests/overview/options/`;
export const GET_GUEST_OVERVIEW_API         = `/api/guests/overview/`;
export const POST_GUESTS_API                = `/api/guests/`;
export const POST_GUESTS_EXCEL_API          = `/api/guests/import/`;

/** ================================
 * 📌 CustomerManufacture 顧客製造
 *  ================================
 */
export const GET_CUSTOMER_MANUFACTURE_OPTIONS_API               = `/api/customer-manufacture/options/`;
export const POST_CUSTOMER_MANUFACTURE_OVERVIEWS_API            = `/api/customer-manufacture/overviews/`;
export const GET_CUSTOMER_MANUFACTURE_CUSTOMERMANUFACTUREID_API = (customerManufactureID) => `/api/customer-manufacture/${customerManufactureID}/`;
export const PUT_CUSTOMER_MANUFACTURE_CUSTOMERMANUFACTUREID_API = GET_CUSTOMER_MANUFACTURE_CUSTOMERMANUFACTUREID_API;
export const POST_CUSTOMER_MANUFACTURE_API                      = `/api/customer-manufacture/`;
export const DELETE_CUSTOMER_MANUFACTURE_API                    = POST_CUSTOMER_MANUFACTURE_API;

/** ================================
 * 📌 CyclePurchase 循環訂單相關
 *  ================================
 */
export const GET_CYCLE_PURCHASE_OPTIONS_API                   = `/api/cycle-purchase/options/`;
export const GET_CYCLE_PURCHASE_OVERVIEW_OPTIONS_API          = `/api/cycle-purchase/overview/options/`;
export const POST_CYCLE_PURCHASE_API                          = `/api/cycle-purchase/`;
export const POST_CYCLE_PURCHASE_OVERVIEW_API                 = `/api/cycle-purchase/overview/`;
export const GET_CYCLE_PURCHASE_API                           = (cycleOrderID) => `/api/cycle-purchase/${cycleOrderID}/`;
export const DELETE_CYCLE_PURCHASE_CYCLEORDERID_API           = (cycleOrderID) => `/api/cycle-purchase/${cycleOrderID}/`;
export const POST_MEMBER_CYCLE_PURCHASE_ORDERS_API            = (memberID) => `/api/members/${memberID}/cycle-purchase/orders/`;
export const POST_MEMBER_CYCLE_PURCHASE_CHANGE_EMPLOYEE_API   = (memberID) => `/api/members/${memberID}/cycle-purchase/change-employee/`;
export const GET_CYCLE_PURCHASE_TEMPORARY_API                 = `/api/cycle-purchase/temporary/`;
export const POST_CYCLE_PURCHASE_TEMPORARY_CYCLEORDERID_API   = (cycleOrderID) => `/api/cycle-purchase/${cycleOrderID}/temporary/`;
export const DELETE_CYCLE_PURCHASE_TEMPORARY_CYCLEORDERID_API = (cycleOrderID) => `/api/cycle-purchase/${cycleOrderID}/temporary/`;

export const GET_CYCLE_PURCHASE_MEMBER_RECEIVER_INFO_API = (memberID) => `/api/cycle-purchase/member/${memberID}/receiver-info/`;

/** ================================
 * 📌 CyclePurchaseEffection 循環訂單變更單
 *  ================================
 */
export const GET_CYCLE_PURCHASE_EFFECT_ORDER_API    = (cycleOrderID, effectID) => `/api/cycle-purchase/${cycleOrderID}/effection/${effectID}/`;
export const POST_CYCLE_PURCHASE_EFFECT_ORDER_API   = `/api/cycle-purchase/effection/`;
export const PUT_CYCLE_PURCHASE_EFFECT_ORDER_API    = effectID => `/api/cycle-purchase/effection/${effectID}/`;
export const DELETE_CYCLE_PURCHASE_EFFECT_ORDER_API = (effectID) => `/api/cycle-purchase/effection/${effectID}/`;
export const POST_CYCLE_PURCHASE_EFFECT_RANGE_API   = `/api/cycle-purchase/effection/range/`;

/** ================================
 * 📌 Appointment 預約相關
 *  ================================
 */
export const GET_APPOINTMENTS_OPTIONS_API                                                   = `/api/appointments/options/`;
export const GET_APPOINTMENTS_FORM_OPTIONS_API                                              = `/api/appointments/form/options/`;
export const GET_APPOINTMENTS_MEMBER_OPTIONS_API                                            = `/api/appointments/member/options/`;
export const GET_APPOINTMENTS_NO_SALES_OPTIONS_API                                          = `/api/appointments/no-sales/options/`;
export const GET_APPOINTMENTS_APPOINTMENTID_API                                             = appointmentID => `/api/appointments/${appointmentID}/`;
export const PUT_APPOINTMENTS_APPOINTMENTID_API                                             = GET_APPOINTMENTS_APPOINTMENTID_API;
export const DELETE_APPOINTMENTS_APPOINTMENTID_API                                          = GET_APPOINTMENTS_APPOINTMENTID_API;
export const GET_APPOINTMENTS_TIMEPICKER_API                                                = `/api/appointments/timepicker/`;
export const GET_APPOINTMENTS_DAILY_API                                                     = `/api/appointments/daily/`;
export const POST_APPOINTMENTS_CHECK_API                                                    = `/api/appointments/check/`;
export const POST_APPOINTMENTS_API                                                          = `/api/appointments/`;
export const PUT_APPOINTMENTS_NOTES_API                                                     = `/api/appointments/notes/`;
export const PUT_APPOINTMENTS_CONFIRM_API                                                   = `/api/appointments/confirm/`;
export const PUT_APPOINTMENTS_ATTEND_API                                                    = `/api/appointments/attend/`;
export const PUT_APPOINTMENTS_PUSH_API                                                      = `/api/appointments/push/`;
export const PUT_APPOINTMENTS_CIRCUIT_API                                                   = `/api/appointments/circuit/`;
export const PUT_APPOINTMENTS_TELEMARKETING_API                                             = `/api/appointments/telemarketing/`;
export const PUT_APPOINTMENTS_SERVE_API                                                     = `/api/appointments/serve/`;
export const GET_APPOINTMENTS_ADVANCED_OPTIONS_API                                          = `/api/appointments/advanced-options/`;
export const GET_APPOINTMENTS_OVERVIEW_API                                                  = `/api/appointments/overview/`;
export const GET_APPOINTMENTS_MEMO_API                                                      = `/api/appointments/memo`;
export const POST_APPOINTMENTS_MEMO_API                                                     = GET_APPOINTMENTS_MEMO_API;
export const GET_APPOINTMENTS_APPOINTMENTID_CONTACT_RECORDS_API                             = (appointmentID) => `/api/appointments/${appointmentID}/contact-records/`;
export const POST_APPOINTMENTS_APPOINTMENTID_CONTACT_RECORDS_API                            = (appointmentID) => `/api/appointments/${appointmentID}/contact-records/`;
export const PUT_APPOINTMENTS_APPOINTMENTID_CONTACT_RECORDS_RECORDID_API                    = (appointmentID, contactID) => `/api/appointments/${appointmentID}/contact-records/${contactID}/`;
export const DELETE_APPOINTMENTS_APPOINTMENTID_CONTACT_RECORDS_TYPE_CUSTOMERID_RECORDID_API = (appointmentID, type, customerID, recordID) => `/api/appointments/${appointmentID}/contact-records/${type}/${customerID}/${recordID}/`;

/** ================================
 * 📌 AuthUser 使用者模組
 *  ================================
 */
export const GET_AUTH_USER_CLUB_PATH_API                       = `/api/me/club/`;
export const PUT_AUTH_USER_SECURITY_API                        = `/api/me/security/`;
export const POST_AUTH_USER_AGENT_OWNER_API                    = `/api/me/agent-owner/`;
export const POST_AUTH_USER_ME_EMPLOYEE_API                    = `/api/me/employee/`;
export const PUT_AUTH_USER_ME_EMPLOYEE_FORGOT_PASSWORD_API     = `/api/me/employee/forgot-password/`;
export const POST_AUTH_USER_ME_UNLOCK_SCREEN                   = `/api/me/unlock-screen/`;
export const PUT_AUTH_USER_ME_CHANGE_PASSWORD_TICKET_API       = (ticket) => `/api/me/change-password/${ticket}/`;
export const DELETE_AUTH_USER_ME_EMPLOYEE_TICKET_API           = (ticket) => `/api/me/employee/${ticket}/`;
export const GET_AUTH_USER_ME_CHECK_FORGOT_PASSWORD_TICKET_API = (ticket) => `/api/me/check/change-password/${ticket}/`;
export const POST_AUTH_USER_ME_NON_CHANGE_PASSWORD_TICKET      = (ticket) => `/api/me/change-password/keep/${ticket}/`;
export const GET_AUTH_USER_ME_MAIL_FORGOT_PASSWORD_API         = (userName) => `/api/me/mail/forgot-password/${userName}/`;

/** ================================
 * 📌 Club 店舖參數專用
 *  ================================
 */
export const GET_CLUBS_STAMP_JPG_API     = `/pic/clubs/stamp.jpg`;
export const GET_CLUBS_ME_API            = `/api/clubs/me/`;
export const PUT_CLUBS_CLUBID_API        = (clubID) => `/api/clubs/${clubID}/`;
export const GET_CLUBS_SETTING_API       = `/api/clubs/setting/`;
export const PUT_CLUBS_SETTING_API       = GET_CLUBS_SETTING_API;
export const GET_CLUBS_SUSPENSION_API    = `/api/clubs/suspension/`;
export const POST_CLUBS_SUSPENSION_API   = GET_CLUBS_SUSPENSION_API;
export const PUT_CLUBS_SUSPENSION_API    = (id) => `/api/clubs/suspension/${id}/`;
export const DELETE_CLUBS_SUSPENSION_API = PUT_CLUBS_SUSPENSION_API;

/** ================================
 * 📌 置物櫃
 *  ================================
 */
export const GET_CABINET_API                = `/api/cabinet/`;
export const POST_CABINET_API               = GET_CABINET_API;
export const GET_CABINET_OPTIONS_API        = `/api/cabinet/options/`;
export const POST_CABINET_LIST_API          = `/api/cabinet/list/`;
export const GET_CABINET_EXCEL_TEMPLATE_API = `/api/cabinet/export/empty/`;
export const GET_CABINET_ID_API             = cabinetID => `/api/cabinet/${cabinetID}/`;
export const POST_CABINET_EXCEL_API         = employeeID => `/api/cabinet/excel/${employeeID}/`;

/** ================================
 * 📌 租櫃相關
 *  ================================
 */
export const POST_RENT_CABINET_API                     = `/api/cabinet/rental/`;
export const GET_RENT_CABINET_OPTIONS_API              = `/api/cabinet/rental/options/`;
export const GET_RENT_CABINET_CHECK_DEBIT_PERSONAL_API = (memberID) => `/api/cabinet/rental/check-debit-personal/${memberID}/`;
export const POST_RENT_CABINET_LIST_API                = `/api/cabinet/rental/list/`;
export const GET_RENT_CABINET_ID_API                   = (cabinetRentalID) => `/api/cabinet/rental/${cabinetRentalID}/`;
export const PUT_QUIT_RENT_CABINET_API                 = (cabinetRentalID) => `/api/cabinet/rental/quit/${cabinetRentalID}/`;
export const DELETE_QUIT_RENT_CABINET_API              = (cabinetRentalID, employeeID) => `/api/cabinet/rental/delete-quit/${cabinetRentalID}/${employeeID}/`;
export const POST_RENT_CABINET_ORDERS_API              = (memberID) => `/api/cabinet/rental/${memberID}/orders/`;
export const GET_RENT_CABINET_MEMBERID_API             = (memberID) => `/api/cabinet/rental/member/${memberID}/`;
export const PUT_RENT_CABINET_MEMBERID_QUIT_API        = (memberID) => `/api/cabinet/rental/member/quit/${memberID}/`;

/** ================================
 * 📌 贈品相關
 *  ================================
 */
export const GET_GIFT_ITEM_ENABLED_API           = `/api/gift-item/enabled/`;
export const GET_GIFT_ITEM_OPTIONS_API           = `/api/gift-item/options/`;
export const GET_GIFT_ITEM_OVERVIEW_API          = `/api/gift-item/overview/`;
export const POST_GIFT_ITEM_API                  = `/api/gift-item/`;
export const PUT_GIFT_ITEM_API                   = (giftID) => `/api/gift-item/${giftID}`;
export const PUT_GIFT_ITEM_ENABLED_API           = (giftID) => `/api/gift-item/${giftID}/enabled/`;
export const GET_GIFT_ITEM_RECORD_OPTIONS_API    = `/api/gift-item/record/options/`;
export const GET_GIFT_ITEM_RECORD_STATISTICS_API = `/api/gift-item/record/statistics/`;
export const GET_GIFT_ITEM_RECORD_OVERVIEW_API   = `/api/gift-item/record/overview/`;
export const POST_GIFT_ITEM_RECORD_API           = `/api/gift-item/record/`;
export const DELETE_GIFT_ITEM_RECORD_API         = `/api/gift-item/record/`;
export const PUT_GIFT_ITEM_RECORD_CLAIMED_API    = (recordID) => `/api/gift-item/record/${recordID}/claimed/`;

/** ================================
 * 📌 Inbody
 *  ================================
 */
export const GET_INBODY_OVERVIEW_OPTIONS_API                         = `/api/inbody/overview/options/`;
export const GET_INBODY_API                                          = `/api/inbody/`;                                                                         // 取得量身資料清單
export const GET_INBODY_MEMBER_HEIGHT_API                            = `/api/inbody/member-height/`;                                                           // 取得會員身高
export const GET_INBODY_EMPLOYEE_HEIGHT_GENDER_API                   = `/api/inbody/employee-height-gender/`;                                                  // 取得教練身高和性別
export const GET_INBODY_INTERVIEW_NOT_MEASURE_STATUS_API             = `/api/inbody/interview-not-measure-status/`;                                            // 面談狀態
export const PUT_INBODY_INTERVIEW_NOT_MEASURE_STATUS_API             = GET_INBODY_INTERVIEW_NOT_MEASURE_STATUS_API;                                            // 更新面談狀態
export const GET_INBODY_MEASURE_RECORDS_API                          = `/api/inbody/measure-records/`;                                                         // 取得完整量身資料清單
export const GET_INBODY_TRIGGER_MEASURE_API                          = `/api/inbody/trigger-measure/`;                                                         // 觸發量身,回傳是否可使用
export const PUT_INBODY_INTERVIEW_API                                = `/api/inbody/interview/`;                                                               // 修改量身面談內容
export const POST_INBODY_CANCEL_MEASURE_API                          = `/api/inbody/cancel-measure/`;                                                          // 取消量身
export const POST_INBODY_IMPORT_EXCEL_API                            = `/api/inbody/import-inbody/`;                                                           // 匯入量身資料
export const POST_INBODY_MACHINES_VERSION_API                        = `/api/inbody/machines/version/`;                                                        // 檢查量身機版本
export const POST_INBODY_IMPORT_EXCEL_370_DM0536_API                 = `/api/inbody/import-inbody/370_DM-0536/`;                                               // 匯入量身資料 特規
export const GET_CHECK_EVALUATION_API                                = `/api/inbody/check-evaluation`;                                                         // 重新產生量身PDF
export const GET_SAVE_INBODY_PDF_API                                 = (measureID) => `/pdf/inbody/${measureID}/save/inbody.pdf`;                                   // 重新產生量身PDF
export const DELETE_INBODY_MEASUREID_API                             = (measureID) => `/api/inbody/${measureID}/`;                                             // 刪除量身資料
export const POST_INBODY_INTERVIEW_MEMBERID_API                      = (memberID) => `/api/inbody/interview/${memberID}/`;                                     // 建立量身面談內容
export const POST_INBODY_MEASUREID_SPORT_ADVISE_SAVE_API             = (measureID) => `/api/inbody/measure/${measureID}/sport-advise/save/`;
export const GET_INBODY_MEMBERID_MEASURE_RANGE_DATE_API              = (memberID) => `/api/inbody/${memberID}/measure-range-date/`;
export const POST_INBODY_MEMBERID_MEASURE_TASK_XFACTOR_MEASUREID_API = (memberID, measureID) => `/api/inbody/${memberID}/measure-task-xfactor/${measureID}/`;
export const POST_INBODY_MEMBERID_MEASURE_TASK_AGREED_MEASUREID_API  = (memberID, measureID) => `/api/inbody/${memberID}/measure-task-agreed/${measureID}/`;


    /** ================================
     * 📌 庫存管理
     *  ================================
     */
    export const GET_PURCHASE_RECEIPT_OPTIONS_API       = (skip = false) => `/api/stock/purchase-receipt/options/${skip}`;
    export const GET_PURCHASE_RECEIPT_ORDER_API         = (purchaseReceiptID) => `/api/stock/purchase-receipt/${purchaseReceiptID}/`;
    export const POST_PURCHASE_RECEIPT_OVERVIEW_API     = `/api/stock/purchase-receipt/overview/`;
    export const DELETE_PURCHASE_RECEIPT_ORDER_API      = (purchaseReceiptID) => `/api/stock/purchase-receipt/${purchaseReceiptID}/`;

    /** ================================
     * 📌 ClubPurchaseReceipt 店鋪進貨單
     *  ================================
     */
    export const GET_CLUB_PURCHASE_RECEIPT_OPTIONS_API           = (skipAll = false) => `/api/club-purchase-receipt/options/${skipAll}`;
    export const POST_CLUB_PURCHASE_RECEIPT_OVERVIEW_API         = `/api/club-purchase-receipt/overview`;
    export const GET_CLUB_PURCHASE_RECEIPT_API                  = (receiptID) => `/api/club-purchase-receipt/${receiptID}`;
    export const GET_CLUB_PURCHASE_RECEIPT_INVENTORY_RECORDS_API = (receiptID) => `/api/club-purchase-receipt/inventory-records/${receiptID}`;
    export const POST_CLUB_PURCHASE_RECEIPT_API                 = `/api/club-purchase-receipt`;

    /** ================================
     * 📌 ClubExceptionOrder 店鋪異常單
     *  ================================
     */
    export const POST_CLUB_EXCEPTION_ORDER_API = `/api/club-exception-order`;

    /** ================================
     * 📌 ClubStockOut 店鋪出貨
     *  ================================
     */
    export const GET_CLUB_STOCK_OUT_OPTIONS_API = (skipAll = false) => `/api/club-stock-out/options/${skipAll}`;
    export const POST_CLUB_STOCK_OUT_OVERVIEW_API = `/api/club-stock-out/overview`;
    export const GET_CLUB_STOCK_OUT_API = (stockOutID) => `/api/club-stock-out/${stockOutID}`;
    export const GET_CLUB_STOCK_OUT_RECORD_API = (stockOutID) => `/api/club-stock-out/${stockOutID}/record`;
    export const POST_CLUB_STOCK_OUT_TRANSFER_API = `/api/club-stock-out/transfer`;
    export const POST_CLUB_STOCK_OUT_RETURN_API = `/api/club-stock-out/defective-return`;
    export const GET_CLUB_STOCK_OUT_DEFECTIVE_ITEMS_API = `/api/club-stock-out/defective-items`;
    export const POST_CLUB_STOCK_OUT_CONSUMPTION_API = `/api/club-stock-out/consumption`;
    export const POST_CLUB_STOCK_OUT_DEFECTIVE_CONSUMPTION_API = `/api/club-stock-out/defective-consumption`;
    export const POST_CLUB_STOCK_OUT_GIFT_CONSUMPTION_API = `/api/club-stock-out/gift-consumption`;

    /** ================================
     * 📌 ClubInventory 店鋪庫存管理
     *  ================================
     */
    export const GET_CLUB_INVENTORY_OPTIONS_API = `/api/club-inventory/options`;
    export const GET_CLUB_INVENTORY_SEARCH_STOCK_SINGLE_API = `/api/club-inventory/search-stock-single`;
    export const POST_CLUB_INVENTORY_COUNT_API = `/api/club-inventory/count`;
    export const POST_CLUB_INVENTORY_OVERVIEW_API = `/api/club-inventory/overview`;
    export const GET_CLUB_INVENTORY_DETAIL_API = (productID, variantID) => `/api/club-inventory/detail/${productID}/${variantID}`;
    export const PUT_CLUB_INVENTORY_QUANTITY_ADJUSTMENT_API = `/api/club-inventory/quantity-adjustment`;
    export const POST_CLUB_INVENTORY_DEFECTIVE_STOCK_IN_API = `/api/club-inventory/defective-stock-in`;
    export const POST_CLUB_INVENTORY_DEFECTIVE_REPORT_API = `/api/club-inventory/defective-report`;
    export const POST_CLUB_INVENTORY_RECORDS_API = (productID, variantID) =>
        `/api/club-inventory/records/${productID}/${variantID}`;
    export const GET_CLUB_INVENTORY_DEFECTIVE_RECORDS_API = (productID, variantID) =>
        `/api/club-inventory/defective-records/${productID}/${variantID}`;
    export const POST_CLUB_INVENTORY_DEFECTIVE_RECORDS_API = `/api/club-inventory/defective-records-page`;

    /** ================================
     * 📌 ClubInspectionOrder 店鋪驗貨單
     *  ================================
     */
    export const POST_CLUB_INSPECTION_ORDER_API = `/api/club-inspection-order`;

    export const GET_INSPECTION_ORDER_API               = (inspectionOrderID) => `/api/stock/inspection-order/${inspectionOrderID}/`;
export const POST_INSPECTION_ORDER_API              = `/api/stock/inspection-order/`;
export const POST_INSPECTION_ORDER_REPORT_ISSUE_API = (inspectionOrderId) => `/api/stock/inspection-order/${inspectionOrderId}/report-issue/`;

/** ================================
 * 📌 DocMembership 入會申請書
 *  ================================
 */
export const GET_DOC_MEMBERSHIP_OPTIONS_API                           = `/api/doc/membership/contracts/options/`;
export const GET_DOC_MEMBERSHIP_HISTORY_API                           = `/api/doc/membership/contracts/history/`;
export const GET_DOC_MEMBERSHIP_ID_API                                = (contractID) => `/api/doc/membership/contracts/${contractID}/`;
export const POST_DOC_MEMBERSHIP_ID_API                               = GET_DOC_MEMBERSHIP_ID_API;
export const DELETE_DOC_MEMBERSHIP_ID_API                             = GET_DOC_MEMBERSHIP_ID_API;
export const POST_DOC_MEMBERSHIP_RANGE_FEE_API                        = `/api/doc/membership/contracts/range-fee/`;
export const GET_DOC_MEMBERSHIP_TEMPORARY_API                         = `/api/doc/membership/contracts/temporary/`;
export const POST_DOC_MEMBERSHIP_TEMPORARY_API                        = GET_DOC_MEMBERSHIP_TEMPORARY_API;
export const DELETE_DOC_MEMBERSHIP_TEMPORARY_API                      = GET_DOC_MEMBERSHIP_TEMPORARY_API;
export const GET_DOC_MEMBERSHIP_TEMPLATE_PDF_API                      = `/api/doc/membership/contracts/template.pdf`;
export const GET_DOC_MEMBERSHIP_CONTRACTS_CONTRACTIDID_CAN_DELETE_API = (contractID) => `/api/doc/membership/contracts/${contractID}/can-delete`;

/** ================================
 * 📌 DocMembershipBatchQuit 會籍批次終止相關
 *  ================================
 */
export const POST_DOC_MEMBERSHIP_BATCH_QUIT_VALIDATE_API = `/api/doc/membership/batch-quit/validate/`;
export const POST_DOC_MEMBERSHIP_BATCH_QUIT_API          = `/api/doc/membership/batch-quit/`;

/** ================================
 * 📌 DocMembershipQuit 終止申請書
 *  ================================
 */
export const GET_DOC_MEMBERSHIP_QUIT_OPTIONS_API                   = `/api/doc/membership/quit/options/`;
export const GET_DOC_MEMBERSHIP_QUIT_HISTORY_API                   = `/api/doc/membership/quit/history/`;
export const GET_DOC_MEMBERSHIP_QUIT_ID_API                        = (contractID) => `/api/doc/membership/quit/${contractID}/`;
export const POST_MEMBERSHIP_QUIT_ID_API                           = GET_DOC_MEMBERSHIP_QUIT_ID_API;
export const DELETE_DOC_MEMBERSHIP_QUIT_ID_API                     = GET_DOC_MEMBERSHIP_QUIT_ID_API;
export const POST_DOC_MEMBERSHIP_QUIT_RANGE_FEE_API                = `/api/doc/membership/quit/range-fee/`;
export const GET_DOC_MEMBERSHIP_QUIT_TEMPORARY_API                 = `/api/doc/membership/quit/temporary/`;
export const POST_DOC_MEMBERSHIP_QUIT_TEMPORARY_API                = GET_DOC_MEMBERSHIP_QUIT_TEMPORARY_API;
export const DELETE_DOC_MEMBERSHIP_QUIT_TEMPORARY_API              = GET_DOC_MEMBERSHIP_QUIT_TEMPORARY_API;
export const GET_DOC_MEMBERSHIP_QUIT_TEMPLATE_PDF_API              = `/api/doc/membership/quit/template.pdf`;
export const GET_DOC_MEMBERSHIP_QUIT_CONTRACTID_INVALID_DIALOG_API = (contractID) => `/api/doc/membership/quit/${contractID}/invalid-dialog`;
export const DELETE_DOC_MEMBERSHIP_CONTRACTID_API                  = (contractID) => `/api/doc/membership/quit/${contractID}`;

/** ================================
 * 📌 DocMembershipSuspend 暫停申請書
 *  ================================
 */
export const GET_DOC_MEMBERSHIP_SUSPEND_OPTIONS_API            = `/api/doc/membership/suspensions/options/`;
export const GET_DOC_MEMBERSHIP_SUSPEND_HISTORY_API            = `/api/doc/membership/suspensions/history/`;
export const GET_DOC_MEMBERSHIP_SUSPEND_CONTRACTID_API         = (contractID) => `/api/doc/membership/suspensions/${contractID}/`;
export const POST_DOC_MEMBERSHIP_SUSPEND_CONTRACTID_API        = GET_DOC_MEMBERSHIP_SUSPEND_CONTRACTID_API;
export const GET_DOC_MEMBERSHIP_SUSPEND_TEMPORARY_API          = `/api/doc/membership/suspensions/temporary/`;
export const POST_DOC_MEMBERSHIP_SUSPEND_TEMPORARY_API         = GET_DOC_MEMBERSHIP_SUSPEND_TEMPORARY_API;
export const DELETE_DOC_MEMBERSHIP_SUSPEND_TEMPORARY_API       = GET_DOC_MEMBERSHIP_SUSPEND_TEMPORARY_API;
export const POST_DOC_MEMBERSHIP_SUSPEND_RANGE_API             = `/api/doc/membership/suspensions/range/`;
export const POST_DOC_MEMBERSHIP_SUSPEND_CONTRACTID_PLUGIN_API = (contractID) => `/api/doc/membership/suspensions/${contractID}/plugin/`;
export const DELETE_DOC_MEMBERSHIP_SUSPENSIONS_API             = `/api/doc/membership/suspensions/`;

/** ================================
 * 📌 DocMembershipTransferIn 移入申請書
 *  ================================
 */
export const GET_DOC_MEMBERSHIP_TRANSFER_IN_UNENTERED_OPTIONS_API       = `/api/doc/membership/transfer-in/unentered/options/`;
export const GET_DOC_MEMBERSHIP_TRANSFER_IN_ENTERED_OPTIONS_ALREADY_API = `/api/doc/membership/transfer-in/entered/options/`;
export const POST_DOC_MEMBERSHIP_TRANSFER_IN_RANGE_API                  = `/api/doc/membership/transfer-in/range`;
export const GET_DOC_MEMBERSHIP_TRANSFER_IN_HISTORY_API                 = `/api/doc/membership/transfer-in/history/`;
export const GET_DOC_MEMBERSHIP_TRANSFER_IN_CONTRACTID_API              = (contractID) => `/api/doc/membership/transfer-in/${contractID}/`;
export const POST_DOC_MEMBERSHIP_TRANSFER_IN_CONTRACTID_API             = GET_DOC_MEMBERSHIP_TRANSFER_IN_CONTRACTID_API;
export const DELETE_DOC_MEMBERSHIP_TRANSFER_IN_CONTRACTID_API           = GET_DOC_MEMBERSHIP_TRANSFER_IN_CONTRACTID_API;
export const GET_DOC_MEMBERSHIP_TRANSFER_IN_TEMPORARY_API               = `/api/doc/membership/transfer-in/temporary/`;
export const POST_DOC_MEMBERSHIP_TRANSFER_IN_TEMPORARY_API              = GET_DOC_MEMBERSHIP_TRANSFER_IN_TEMPORARY_API;
export const DELETE_DOC_MEMBERSHIP_TRANSFER_IN_TEMPORARY_API            = GET_DOC_MEMBERSHIP_TRANSFER_IN_TEMPORARY_API;

/** ================================
 * 📌 DocMembershipTransferOut 移出申請書
 *  ================================
 */
export const GET_DOC_MEMBERSHIP_TRANSFER_OUT_UNMOVEOUT_OPTIONS_API = `/api/doc/membership/transfer-out/unmoveout/options/`;
export const GET_DOC_MEMBERSHIP_TRANSFER_OUT_MOVEOUT_OPTIONS_API   = `/api/doc/membership/transfer-out/moveout/options/`;
export const GET_DOC_MEMBERSHIP_TRANSFER_OUT_HISTORY_API           = `/api/doc/membership/transfer-out/history/`;
export const GET_DOC_MEMBERSHIP_TRANSFER_OUT_CONTRACTID_API        = (contractID) => `/api/doc/membership/transfer-out/${contractID}/`;
export const PUT_DOC_MEMBERSHIP_TRANSFEROUT_CONTRACTID_PATH        = GET_DOC_MEMBERSHIP_TRANSFER_OUT_CONTRACTID_API;
export const POST_DOC_MEMBERSHIP_TRANSFER_OUT_CONTRACTID_API       = GET_DOC_MEMBERSHIP_TRANSFER_OUT_CONTRACTID_API;
export const DELETE_DOC_MEMBERSHIP_TRANSFER_OUT_CONTRACTID_API     = GET_DOC_MEMBERSHIP_TRANSFER_OUT_CONTRACTID_API;
export const GET_DOC_MEMBERSHIP_TRANSFER_OUT_TEMPORARY_API         = `/api/doc/membership/transfer-out/temporary/`;
export const POST_DOC_MEMBERSHIP_TRANSFER_OUT_TEMPORARY_API        = GET_DOC_MEMBERSHIP_TRANSFER_OUT_TEMPORARY_API;
export const DELETE_DOC_MEMBERSHIP_TRANSFER_OUT_TEMPORARY_API      = GET_DOC_MEMBERSHIP_TRANSFER_OUT_TEMPORARY_API;

/** ================================
 * 📌 DocMembershipTransferOver 轉讓申請書
 *  ================================
 */
export const GET_DOC_MEMBERSHIP_TRANSFER_OVER_OPTIONS_API       = `/api/doc/membership/transfer-over/options/`;
export const GET_DOC_MEMBERSHIP_TRANSFER_OVER_HISTORY_API       = `/api/doc/membership/transfer-over/history/`;
export const GET_DOC_MEMBERSHIP_TRANSFER_OVER_CONTRACTID_API    = (contractID) => `/api/doc/membership/transfer-over/${contractID}/`;
export const POST_DOC_MEMBERSHIP_TRANSFER_OVER_CONTRACTID_API   = GET_DOC_MEMBERSHIP_TRANSFER_OVER_CONTRACTID_API;
export const DELETE_DOC_MEMBERSHIP_TRANSFER_OVER_CONTRACTID_API = GET_DOC_MEMBERSHIP_TRANSFER_OVER_CONTRACTID_API;
export const GET_DOC_MEMBERSHIP_TRANSFER_OVER_TEMPORARY_API     = `/api/doc/membership/transfer-over/temporary/`;
export const POST_DOC_MEMBERSHIP_TRANSFER_OVER_TEMPORARY_API    = GET_DOC_MEMBERSHIP_TRANSFER_OVER_TEMPORARY_API;
export const DELETE_DOC_MEMBERSHIP_TRANSFER_OVER_TEMPORARY_API  = GET_DOC_MEMBERSHIP_TRANSFER_OVER_TEMPORARY_API;

/** ================================
 * 📌 DocHealthDeclaration 健康申告書
 *  ================================
 */
export const GET_DOC_HEALTH_DECLARATION_OPTION_API        = `/api/doc/health-declaration/options/`;
export const GET_DOC_HEALTH_DECLARATION_HISTORY_API       = `/api/doc/health-declaration/history/`;
export const GET_DOC_HEALTH_DECLARATION_CONTRACTID_API    = (contractID) => `/api/doc/health-declaration/${contractID}/`;
export const POST_DOC_HEALTH_DECLARATION_CONTRACTID_API   = GET_DOC_HEALTH_DECLARATION_CONTRACTID_API;
export const DELETE_DOC_HEALTH_DECLARATION_CONTRACTID_API = GET_DOC_HEALTH_DECLARATION_CONTRACTID_API;
export const GET_DOC_HEALTH_DECLARATION_TEMPORARY_API     = `api/doc/health-declaration/temporary/`;
export const POST_DOC_HEALTH_DECLARATION_TEMPORARY_API    = GET_DOC_HEALTH_DECLARATION_TEMPORARY_API;
export const DELETE_DOC_HEALTH_DECLARATION_TEMPORARY_API  = GET_DOC_HEALTH_DECLARATION_TEMPORARY_API;
export const GET_DOC_HEALTH_DECLARATION_VALID_API         = `/api/doc/health-declaration/is-valid/`;
export const GET_DOC_HEALTH_DECLARATION_VALID_TODAY_API   = `/api/doc/health-declaration/is-valid-today/`;

/** ================================
 * 📌 Document 文書相關
 *  ================================
 */

export const GET_PAYMENT_CREDIT_CARD_PDF_API               = `/document/payment-credit-card.pdf`;
export const GET_DOCUMENT_LEADERBOARD_POSTER_API           = `/document/leaderboard/poster/`;
export const GET_DOCUMENT_TRANSCRIPT_API                   = `/document/leaderboard/transcript/`;
export const GET_DOCUMENT_EVALUATION_API                   = (key) => `/document/${key}/measure/body-evaluation/`;
export const GET_DOCUMENT_MEASURE_SPORT_ADVISE_API         = (key) => `/document/${key}/measure/sport-advise/`;
export const GET_DOCUMENT_MULTIPLE_MEASURE_INFORMATION_API = (key) => `/document/${key}/measure/multiple-information/`;

/** ================================
 * 📌 EMPLOYEES 教練相關
 *  ================================
 */
export const GET_EMPLOYEES_OPTIONS_API             = `/api/employees/options/`;
export const GET_EMPLOYEES_OPTIONS_CLUBID_API      = (clubID) => `/api/employees/options/${clubID}/`;
export const GET_EMPLOYEES_API                     = `/api/employees/`;
export const POST_EMPLOYEES_API                    = GET_EMPLOYEES_API;
export const PUT_EMPLOYEES_API                     = GET_EMPLOYEES_API;
export const GET_EMPLOYEES_STATUS_OPTIONS_API      = `/api/employees/status/options/`;
export const GET_EMPLOYEES_RANK_TYPE_OPTIONS_API   = `/api/employees/rank-type/options/`;
export const GET_EMPLOYEES_OVERVIEW_ADVANCE_API    = `/api/employees/overview/advance/`;
export const GET_EMPLOYEES_EMPLOYEEID_API          = (employeeID) => `/api/employees/${employeeID}/`;
export const GET_EMPLOYEES_NO_DELETED_OPTIONS_API  = `/api/employees/no-deleted/options/`;
export const GET_EMPLOYEES_LIST_STATUS_OPTIONS_API = `/api/employees/list/status/options/`;
export const PUT_EMPLOYEES_STATUS_API              = `/api/employees/status/`;

/** ================================
 * 📌 EmployeeCheckIn 教練打卡和出勤
 *  ================================
 */
export const GET_EMPLOYEES_CHECKIN_EMPLOYEEID_API        = (employeeID) => `/api/employees/checkin/${employeeID}/`;
export const GET_EMPLOYEES_CHECKIN_EMPLOYEEID_EXPORT_API = (employeeID) => `/api/employees/checkin/${employeeID}/export/`;

/** ================================
 * 📌 EmployeeSchedule 教練班表
 *  ================================
 */
export const GET_EMPLOYEE_SCHEDULE_API                = `/api/employee-schedule/`;
export const GET_EMPLOYEE_SCHEDULE_RESOURCE_API       = `/api/employee-schedule/resource/`;
export const POST_EMPLOYEE_SCHEDULE_COACH_SUPPORT_API = `/api/employee-schedule/coach-support/`;
export const POST_EMPLOYEE_SCHEDULE_COACH_OUT_API     = `/api/employee-schedule/coach-out/`;
export const POST_EMPLOYEE_SCHEDULE_CIRCUIT_API       = `/api/employee-schedule/circuit/`;
export const POST_EMPLOYEE_SCHEDULE_APO_API           = `/api/employee-schedule/apo/`;
export const POST_EMPLOYEE_SCHEDULE_OTHERS_API        = `/api/employee-schedule/others/`;
export const DELETE_EMPLOYEE_SCHEDULE_OTHERS_API      = `/api/employee-schedule/others/`;
export const GET_EMPLOYEE_SCHEDULE_EMPLOYEE_API       = `/api/employee-schedule/employee/`;
export const GET_EMPLOYEE_SCHEDULE_DUTY_LIST_API      = `/api/employee-schedule/duty-list/`;

/** ================================
 * 📌 教練網頁綁定狀態
 *  ================================
 */
export const GET_EMPLOYEE_LINE_BINDING_INFO_API    = (employeeID) => `/api/employees/${employeeID}/line-binding-info/`;
export const DELETE_EMPLOYEE_LINE_BINDING_INFO_API = (employeeID) => `/api/employees/${employeeID}/line-binding-info/`;

/** ================================
 * 📌 會員相關
 *  ================================
 */
export const GET_MEMBERS_OPTIONS_API                    = `/api/members/options/`;
export const POST_MEMBERS_OVERVIEW_API                  = `/api/members/overview/`;
export const GET_MEMBERS_MEMBERID_USER_API              = (memberID) => `/pic/members/${memberID}/user.jpg`;
export const POST_MEMBERS_MEMBERID_PHOTO_API            = (memberID) => `/api/members/${memberID}/photo/`;
export const POST_MEMBERS_MEMBERID_TRANSCRIPT_PHOTO_API = (memberID) => `/api/members/${memberID}/transcript/photo/`;
/** 運動次數 */
export const GET_MEMBER_WORKOUTS_API = `/api/member-workouts/`;
export const GET_MEMBERS_CHECKIN_OPTIONS_API = `/api/members/checkin/options/`;
export const GET_MEMBERS_CHECKIN_API = `/api/members/checkin/`;
export const POST_MEMBER_CHECKIN_API = GET_MEMBERS_CHECKIN_API;
/** 來店刷退 */
export const POST_MEMBERS_CHECKOUT_API       = `/api/members/checkout/`;
export const GET_MEMBERS_CHECKOUT_PEOPLE_API = `/api/members/checkout/people/`;
/** 聯繫 */
export const GET_MEMBERS_CONTACT_RECORDS_OPTIONS_API                                        = `/api/members/contact-records/options/`;
export const GET_MEMBERS_MEMBERID_CONTACT_RECORDS_API                                       = (memberID) => `/api/members/${memberID}/contact-records/`;
export const GET_MEMBERS_MEMBERID_CONTACT_RECORDS_LAST5_API                                 = (memberID) => `/api/members/${memberID}/contact-records/last5/`;
export const POST_MEMBERS_MEMBERID_CONTACT_RECORDS_API                                      = (memberID) => `/api/members/${memberID}/contact-records/`;
export const GET_MEMBERS_MEMBERID_CONTACT_RECORDS_CONTACTID_CONTACT_HISTORIES_API           = (memberID, contactID) => `/api/members/${memberID}/contact-records/${contactID}/contact-histories/`;
export const PUT_MEMBERS_MEMBERID_CONTACT_RECORDS_CONTACTID_API                             = (memberID, contactID) => `/api/members/${memberID}/contact-records/${contactID}/`;
export const DELETE_MEMBERS_MEMBERID_CONTACT_RECORDS_CONTACTID_API                          = (memberID, contactID) => `/api/members/${memberID}/contact-records/${contactID}/`;
export const PUT_MEMBERS_MEMBERID_CONTACT_RECORDS_CONTACTID_CONTACT_HISTORIES_HISTORYID_API = (memberID, contactID, historyID) => `/api/members/${memberID}/contact-records/${contactID}/contact-histories/${historyID}/`;
export const POST_MEMBERS_FILTER_CONTACT_GROUP_RECORDS_API                                  = (memberID, filterType) => `/api/members/${memberID}/contact-records/?filterType=${filterType}`;
/** 循環訂單 */
export const GET_MEMBER_CYCLE_PURCHASE_API          = (memberID) => `/api/members/${memberID}/cycle-purchase/`;
export const GET_CHECK_VALID_MEMBER_CYCLE_ORDER_API = (memberID) => `/api/members/${memberID}/cycle-purchase/checkvalid/`;
export const GET_MEMBER_CYCLE_PURCHASE_HISTORY_API  = (memberID, cycleOrderID) => `/api/members/${memberID}/cycle-purchase/${cycleOrderID}/history/`;
export const GET_MEMBER_CYCLE_PURCHASE_FUTURE_API   = (memberID, cycleOrderID) => `/api/members/${memberID}/cycle-purchase/${cycleOrderID}/future/`;
export const GET_MEMBER_CYCLE_PURCHASE_TIMELINE_API = (memberID) => `/api/members/${memberID}/cycle-purchase/timeline/`;
/** 快速名單 */
export const GET_MEMBER_FILTER_OPTIONS_API           = `/api/member/filter/options/`;
export const GET_MEMBER_FILTER_BIRTHDAY_API          = `/api/member/filter/birthday/`;
export const GET_MEMBER_FILTER_WORKOUT_FREQUENCY_API = `/api/member/filter/workout-frequency/`;
export const GET_MEMBER_FILTER_CROSS_CLUB_API        = `/api/member/filter/cross-club/`;
export const GET_MEMBER_FILTER_CROSS_CLUB_VISIT_API  = `/api/member/filter/cross-club-visits/`;
export const GET_MEMBER_FILTER_HUNDRED_T_SHIRT_API   = `/api/member/filter/hundred-t-shirt/`;
export const GET_MEMBER_FILTER_RENEW_API             = `/api/member/filter/renew/`;
export const GET_MEMBER_FILTER_LEAVE_API             = `/api/member/filter/leave/`;
export const GET_MEMBER_FILTER_INVALID_API           = `/api/member/filter/invalid/`;
export const GET_MEMBER_FILTER_NEW_API               = `/api/member/filter/new/`;
export const GET_MEMBER_FILTER_HEALTHCARE_API        = `/api/member/filter/healthcare/`;
export const GET_MEMBER_FILTER_OVERDRAFT_API         = `/api/member/filter/overdraft/`;
export const GET_MEMBER_FILTER_MONTH_FEE_API         = `/api/member/filter/month-fee/`;
export const GET_MEMBER_FILTER_MEASURED_API          = `/api/member/filter/measured/`;
export const GET_MEMBER_FILTER_MEASURE_NOT_YET_API   = `/api/member/filter/measure-not-yet/`;
export const GET_MEMBER_FILTER_MEASURE_RESULT_API    = `/api/member/filter/measure-result/`;
export const GET_MEMBER_FILTER_HIGH_RISK_API         = `/api/member/filter/high-risk/`;
/** 快速名單 - 聯繫 */
export const GET_MEMBER_FILTER_CONTACT_GROUP_API       = (filterType) => `/api/member/filter-contact/${filterType}/group/`;
export const POST_MEMBER_FILTER_CONTACT_GROUP_API      = (filterType) => `/api/member/filter-contact/${filterType}/group/`;
export const DELETE_MEMBER_FILTER_CONTACT_GROUP_API    = (filterType, filterID) => `/api/member/filter-contact/${filterType}/group/?filterID=${filterID}`;
export const POST_MEMBER_FILTER_CONTACT_GROUP_ITEM_API = (filterType) => `/api/member/filter-contact/${filterType}/group-items/`;

/** ================================
 * 📌 快速名單 - Excel下載
 *  ================================
 */
export const POST_MEMBER_FILTER_EXPORT_WORKOUT_FREQUENCY_API = `/api/member/filter-export/workout-frequency/`;
export const POST_MEMBER_FILTER_EXPORT_CROSS_CLUB_API        = `/api/member/filter-export/cross-club/`;
export const POST_MEMBER_FILTER_EXPORT_CROSS_CLUB_VISIT_API  = `/api/member/filter-export/cross-club-visits/`;
export const POST_MEMBER_FILTER_EXPORT_HUNDRED_T_SHIRT_API   = `/api/member/filter-export/hundred-t-shirt/`;
export const POST_MEMBER_FILTER_EXPORT_NEW_API               = `/api/member/filter-export/new/`;
export const POST_MEMBER_FILTER_EXPORT_INVALID_API           = `/api/member/filter-export/invalid/`;
export const POST_MEMBER_FILTER_EXPORT_BIRTHDAY_API          = `/api/member/filter-export/birthday/`;
export const POST_MEMBER_FILTER_EXPORT_LEAVE_API             = `/api/member/filter-export/leave/`;
export const POST_MEMBER_FILTER_EXPORT_RENEW_API             = `/api/member/filter-export/renew/`;
export const POST_MEMBER_FILTER_EXPORT_HEALTHCARE_API        = `/api/member/filter-export/healthcare/`;
export const POST_MEMBER_FILTER_EXPORT_MEASURE_NOT_YET_API   = `/api/member/filter-export/measure-not-yet/`;
export const POST_MEMBER_FILTER_EXPORT_MEASURED_API          = `/api/member/filter-export/measured/`;
export const POST_MEMBER_FILTER_EXPORT_OVERDRAFT_API         = `/api/member/filter-export/overdraft/`;
export const POST_MEMBER_FILTER_EXPORT_MONTH_FEE_API         = `/api/member/filter-export/month-fee/`;
export const POST_MEMBER_FILTER_EXPORT_OVERVIEW_API          = `/api/member/filter-export/overview/`;
export const POST_MEMBER_FILTER_EXPORT_MEASURE_RESULT_API    = `/api/member/filter-export/measure-result/`;
export const POST_MEMBER_FILTER_MEASURE_RESULT_EXCEL_API     = `/api/member/filter-export/measure-result-excel/`;
export const POST_MEMBER_FILTER_EXPORT_HIGH_RISK_API         = `/api/member/filter-export/high-risk/`;

/** ================================
 * 📌 贈品發送紀錄清單
 *  ================================
 */
export const GET_MEMBERS_GIFT_ITEM_API = (memberID) => `/api/members/${memberID}/gift-item/records/`;

/** ================================
 * 📌 會員詳細頁面相關
 *  ================================
 */
export const GET_MEMBER_PROFILE_API                     = (memberID) => `/api/members/${memberID}/profile/`;
export const GET_MEMBER_PROFILE_TIP_API                 = (memberID) => `/api/members/${memberID}/tip/`;
export const POST_MEMBER_PROFILE_PROTEIN_PUSH_API       = (memberID) => `/api/members/${memberID}/profile/protein-push/`;
export const POST_MEMBER_PROFILE_PROBIOTICS_PUSH_API    = (memberID) => `/api/members/${memberID}/profile/probiotics-push/`;
export const POST_MEMBER_PROFILE_CALCIUM_PUSH_API       = (memberID) => `/api/members/${memberID}/profile/calcium-push/`;
export const POST_MEMBER_PROFILE_SMART_RING_PUSH_API    = (memberID) => `/api/members/${memberID}/profile/smart-ring-push/`;
export const POST_MEMBER_PROFILE_HUNDRED_T_SHIRT_API    = (memberID) => `/api/members/${memberID}/profile/hundred-t-shirt/`;
export const POST_MEMBER_PROFILE_MEASURE_DAY_API        = (memberID) => `/api/members/${memberID}/profile/measure-day/`;
export const POST_MEMBER_PROFILE_NOTES_API              = (memberID) => `/api/members/${memberID}/profile/notes/`;
export const POST_MEMBER_PROFILE_TASKS_API              = (memberID) => `/api/members/${memberID}/profile/tasks/`;
export const PUT_MEMBER_PROFILE_TASKS_API               = (memberID, taskID) => `/api/members/${memberID}/profile/tasks/${taskID}/`;
export const DELETE_MEMBER_PROFILE_TASKS_API            = PUT_MEMBER_PROFILE_TASKS_API;
export const GET_MEMBER_PROFILE_BASIC_API               = (memberID) => `/api/members/${memberID}/profile-basic/`;
export const POST_MEMBER_PROFILE_BASIC_API              = GET_MEMBER_PROFILE_BASIC_API;
export const GET_MEMBER_PROFILE_PAYMENTS_MEMBERSHIP_API = (memberID, paymentID) => `/api/members/${memberID}/profile-payments-membership/${paymentID}/`;

export const POST_MEMBER_PROFILE_PAYMENTS_MEMBERSHIPS_API = (memberID) => `/api/members/${memberID}/profile-payments/memberships/`;
export const GET_MEMBER_PROFILE_PAYMENTS_INVOICES_API     = (memberID) => `/api/members/${memberID}/profile-invoices/`;
export const POST_MEMBER_PROFILE_PAYMENTS_INVOICES_API    = GET_MEMBER_PROFILE_PAYMENTS_INVOICES_API;
export const PUT_MEMBER_PROFILE_NOTIFY_SMS_API            = (memberID) => `/api/members/${memberID}/profile/notify-sms/`;
export const PUT_MEMBER_PROFILE_NOTIFY_MARKETING_ACTION_API = (memberID) => `/api/members/${memberID}/profile/notify-marketing-action/`;
export const GET_MEMBER_PROFILE_HEALTH_DECLARATION_API    = (memberID) => `/api/members/${memberID}/profile-health-declaration/`;
export const GET_MEMBER_PROTEINPUSH_OPTIONS_API           = (memberID) => `/api/members/${memberID}/profile/protein-push/options/`;
export const GET_MEMBER_PROBIOTICSPUSH_OPTIONS_API        = (memberID) => `/api/members/${memberID}/profile/probiotics-push/options/`;
export const GET_MEMBER_CALCIUMPUSH_OPTIONS_API           = (memberID) => `/api/members/${memberID}/profile/calcium-push/options/`;

export const GET_MEMBER_PROFILE_PAYMENTS_API              = (memberID) => `/api/members/${memberID}/profile-payments/`;
export const POST_MEMBER_PROFILE_PAYMENTS_CREDIT_CARD_API = (memberID) => `/api/members/${memberID}/profile-payments/creditcard/`;
export const POST_MEMBER_PROFILE_PAYMENTS_BANK_API        = (memberID) => `/api/members/${memberID}/profile-payments/bank/`;

export const GET_MEMBER_PAYMENTS_OPTIONS_API     = (memberID) => `/api/members/${memberID}/payment/options/`;
export const GET_MEMBER_DEFAULT_CREDIT_CARD_API  = (memberID) => `/api/members/${memberID}/default-credit-card/`;
export const GET_MEMBER_PAYMENT_API              = (memberID, paymentID) => `/api/members/${memberID}/payment/${paymentID}/`;
export const GET_MEMBER_PAYMENT_HISTORY_API      = (memberID, paymentID) => `/api/members/${memberID}/payment/${paymentID}/history/`;
export const POST_MEMBER_PAYMENT_PLUGIN_API      = (memberID, paymentID) => `/api/members/${memberID}/payment/${paymentID}/plugin/`;
export const GET_MEMBER_DOC_PAYMENT_PLUGIN_API   = (memberID, paymentID, extension) => `/api/members/${memberID}/doc/payment/${paymentID}/plugin.${extension}`;
export const GET_MEMBER_DOC_PAYMENT_CONTRACT_API = (memberID, paymentID) => `/api/members/${memberID}/doc/payment/${paymentID}/contract.pdf`;

/** ================================
 * 📌 會員欠費訂單(只要是訂單就在這)
 *  ================================
 */
export const GET_MEMBERS_MEMBERSID_UNCHECKOUT_ORDERS                       = (memberID) => `/api/members/${memberID}/uncheckout-orders/`;
export const GET_MEMBERS_MEMBERSID_UNCHECKOUT_DEVICE_ORDERS                = (memberID) => `/api/members/${memberID}/uncheckout-device-orders/`;
export const POST_MEMBERS_MEMBERSID_UNCHECKOUT_DEVICE_ORDERS_PACKING_BATCH = (memberID) => `/api/members/${memberID}/uncheckout-device-orders/packing-batch/`;
export const GET_MEMBERS_MEMBERSID_ONSITE_ORDERS                           = (memberID) => `/api/members/${memberID}/onsite-orders/`;

/** ================================
 * 📌 會員詳細頁面取得打卡運動時間
 *  ================================
 */
export const GET_MEMBER_WORKOUT_TIME_LINE_API  = (memberID) => `/api/members/${memberID}/workout-timeline/`;
export const GET_MEMBER_WORKOUT_CALENDAR_API   = (memberID) => `/api/members/${memberID}/workout-calendar/`;
export const DELETE_MEMBER_MEMBERWORKOUTID_API = `/api/members/workout/`;

/** ================================
 * 📌 會員網頁綁定狀態
 *  ================================
 */
export const GET_MEMBER_LINE_BINDING_INFO_API    = (memberID) => `/api/members/${memberID}/profile-line-binding-info/`;
export const DELETE_MEMBER_LINE_BINDING_INFO_API = (memberID) => `/api/members/${memberID}/profile-line-binding-info/`;

/** ================================
 * 📌 取得 QRCODE
 *  ================================
 */
export const GET_MEMBER_QRCODE_API = (memberID) => `api/members/${memberID}/qrcode/`;
export const GET_EMPLOYEE_QRCODE_API = (employeeID) => `/api/employee/${employeeID}/qrcode/`;

/** ================================
 * 📌 會員詳細頁面會籍Bar
 *  ================================
 */
export const GET_MEMBER_MEMBERSHIPS_API                    = (memberID) => `api/members/${memberID}/memberships/`;
export const GET_MEMBER_MEMBERSHIP_API                     = (memberID, membershipID) => `api/members/${memberID}/memberships/${membershipID}/`;
export const GET_MEMBER_MEMBERSHIP_RANGES_API              = (memberID, membershipID) => `api/members/${memberID}/memberships/${membershipID}/bar-ranges/`;
export const GET_MEMBER_MEMBERSHIP_ITEM_REASONS_API        = (memberID, membershipID) => `api/members/${memberID}/memberships/${membershipID}/item-reasons/`;
export const POST_MEMBER_MEMBERSHIP_ORDERS_API             = (memberID) => `api/members/${memberID}/memberships/orders/`;
export const POST_MEMBER_MEMBERSHIP_MANUAL_GIFT_API        = (memberID, membershipID) => `api/members/${memberID}/memberships/${membershipID}/manual-gift/`;
export const DELETE_MEMBER_MEMBERSHIP_MANUAL_GIFT_ITEM_API = (memberID, membershipID, itemID) => `api/members/${memberID}/memberships/${membershipID}/manual-gift/${itemID}/`;
export const GET_MEMBER_MEMBERSHIP_UNUSED_SUSPEND_API      = (memberID, membershipID) => `/api/members/${memberID}/memberships/${membershipID}/unused-suspend`;

/** ================================
 * 📌 通知使用
 *  ================================
 */
export const GET_NOTIFICATION_OVERVIEW_OPTIONS_API    = `/api/notification/overview/options/`;                            // 簡訊清單排序下拉選項
export const GET_NOTIFICATION_COUNT_API               = `/api/notification/count/`;                                       // 取得通知未讀數量總和
export const GET_NOTIFICATION_UNREAD_API              = `/api/notification/unread/`;                                      // 取得通知列表未讀數量
export const POST_NOTIFICATION_OVERVIEW_API           = `/api/notification/overview/`;                                    // 取得通知清單
export const PUT_NOTIFICATION_READ_NOTIFICATIONID_API = (notificationID) => `/api/notification/read/${notificationID}/`;  // 設定通知為已讀


/** ================================
 * 📌 People 依來源 TargetTypeEnum 類型查詢AutoComplete清單
 *  ================================
 */
export const GET_PEOPLE_API = `/api/people/`;

/** ================================
 * 📌 營運報表
 *  ================================
 */
export const GET_ORDER_ACCOUNT_BOOK_OPTIONS_API   = `/api/orders/account-book/options/`;
export const GET_ORDER_ACCOUNT_BOOK_API           = `/api/orders/account-book/`;
export const POST_ORDER_ACCOUNT_BOOK_FUND_API     = `/api/orders/account-book/fund/`;
export const POST_ORDER_ACCOUNT_BOOK_SETTLE_API   = `/api/orders/account-book/settle/`;
export const DELETE_ORDER_ACCOUNT_BOOK_SETTLE_API = POST_ORDER_ACCOUNT_BOOK_SETTLE_API;
export const POST_ORDER_ACCOUNT_BOOK_ITEMS_API    = `/api/orders/account-book/items/`;
export const PUT_ORDER_ACCOUNT_BOOK_ITEM_API      = (itemID) => `/api/orders/account-book/items/${itemID}/`;
export const DELETE_ORDER_ACCOUNT_BOOK_ITEM_API   = PUT_ORDER_ACCOUNT_BOOK_ITEM_API;

/** ================================
 * 📌 一般訂單
 *  ================================
 */
export const GET_ORDER_ID_API                 = (orderID) => `/api/orders/${orderID}/`;
export const POST_ORDERS_OVERVIEW_API         = `/api/orders/overview/`;
export const GET_ORDERS_OVERVIEW_OPTIONS_API  = `/api/orders/overview/options/`;
export const POST_ORDERS_OVERVIEW_ADVANCE_API = `/api/orders/overview/advance/`;
export const POST_ORDER_ISSUING_INVOICE_API   = (orderID) => `/api/orders/${orderID}/issuing-invoice/`;
export const GET_ORDER_ALLOWANCE_DIALOG_API   = (orderID) => `/api/orders/${orderID}/allowance-dialog/`;
export const POST_ORDER_ALLOWANCE_CONFIRM_API = `/api/orders/allowance-confirm/`;
export const GET_ORDER_REISSUING_DIALOG_API   = (orderID) => `/api/orders/${orderID}/reissuing-dialog/`;
export const PUT_ORDER_REISSUING_DIALOG_API   = GET_ORDER_REISSUING_DIALOG_API;
export const POST_ORDER_REISSUING_API         = (orderID) => `/api/orders/${orderID}/reissuing/`;
export const PUT_ORDER_DELETE_API             = (orderID) => `/api/orders/${orderID}/delete/`;
export const PUT_ORDER_REINIT_API             = (orderID) => `/api/orders/${orderID}/reinit/`;

/** ================================
 * 📌 批次訂單
 *  ================================
 */
export const GET_ORDER_BATCH_PAYMENT_OPTIONS_API       = '/api/orders/batch-payments/options/';
export const GET_ORDER_BATCH_PAYMENT_API               = '/api/orders/batch-payments/';
export const POST_ORDER_BATCH_PAYMENT_EXPORT_ORDER_API = '/api/orders/batch-payments-export/export-order/';
export const GET_ORDER_BATCH_PAYMENT_BILLING_API       = (billingID) => `/api/orders/batch-payments/${billingID}/`;
export const DELETE_ORDER_BATCH_PAYMENT_BILLING_API    = GET_ORDER_BATCH_PAYMENT_BILLING_API;
export const POST_ORDER_BATCH_PAYMENT_CONFIRM_API      = '/api/orders/batch-payments/confirm/';
export const POST_ORDER_BATCH_PAYMENT_ACH_EXPORT_API   = (billingID) => `/api/orders/batch-payments-export/${billingID}/export-ach/`;
export const POST_ORDER_BATCH_PAYMENT_ACH_IMPORT_API   = (billingID) => `/api/orders/batch-payments/${billingID}/import-ach/`;

/** ================================
 * 📌 抵用券訂單
 *  ================================
 */
export const GET_CAMPAIGN_OVERVIEW_OPTIONS_API  = `/api/campaigns/overview/options`;
export const POST_CAMPAIGN_OVERVIEW_API         = `/api/campaigns/overview`;

/** ================================
 * 📌 訂單結帳用
 *  ================================
 */
export const GET_ORDERS_CHECKOUT_OPTIONS_API              = `/api/orders/checkout/options/`;
export const GET_ORDERS_CHECKOUT_API                      = `/api/orders/checkout/`;
export const POST_ORDERS_CHECKOUT_BY_PEOPLE_API           = `/api/orders/checkout/by-people/`;
export const POST_ORDERS_CHECKOUT_CHECK_DEVICE_ORDER_API  = (memberID) => `/api/orders/checkout/check-device-order/${memberID}/`;

export const GET_ORDERS_CHECKOUT_CYCLE_PURCHASE_API      = `/api/orders/checkout/cycle-purchase/`;
export const POST_ORDERS_CHECKOUT_BY_CYCLE_PURCHASE_API = `/api/orders/checkout/by-cycle-purchase/`;
export const POST_ORDERS_CHECKOUT_CAMPAIGN_API               = `/api/orders/checkout/items/campaign/`;

/** ================================
 * 📌 退訂單
 *  ================================
 */
export const GET_ORDER_ALLOWANCE_ID_API               = (orderID) => `/api/orders/${orderID}/allowance-dialog/`;
export const GET_ORDER_INVALID_ABANDON_ID_API         = (orderID) => `/api/orders/${orderID}/invalid-dialog/`;
export const POST_ORDER_INVALID_ABANDON_CONFIRM_API   = `/api/orders/invalid-confirm/`;
export const GET_ORDER_ABANDON_ALLOWANCE_ID_API       = (orderID) => `/api/orders/${orderID}/allowance-history/`;
export const POST_ORDER_ABANDON_ALLOWANCE_CONFIRM_API = `/api/orders/invalid-allowance-confirm/`;

/** ================================
 * 📌 統計報表數據
 *  ================================
 */
export const GET_ORDERS_STATISTICS_OPTIONS_API      = `/api/orders/statistics/options/`;
export const GET_ORDERS_STATISTICS_SITE_API         = `/api/orders/statistics/on-site/`;
export const GET_ORDERS_STATISTICS_ALL_API          = `/api/orders/statistics/on-all/`;
export const GET_ORDERS_STATISTICS_FILTER_ITEMS_API = (target, filterType) => `/api/orders/statistics/${target}/${filterType}/items/`;
export const POST_ORDERS_STATISTICS_EXPORT_SITE_API = `/api/orders/statistics/export/on-site/`;
export const POST_ORDERS_STATISTICS_EXPORT_ALL_API  = `/api/orders/statistics/export/on-all/`;
export const GET_AGP_REPORT_DETAIL_API              = (dateString, dataKeyName) => `/api/reports/monthly/${dateString}/agp/${dataKeyName}-details`;
export const GET_AGP_GUEST_REPORT_DETAIL_API        = (dateString, dataKeyName) => `/api/reports/monthly/${dateString}/agp-guest/${dataKeyName}-details`;
export const GET_CALLS_REPORT_DETAIL_API            = (dateString, dataKeyName) => `/api/reports/monthly/${dateString}/calls/${dataKeyName}-details`;
export const GET_APO_REPORT_DETAIL_API              = (dateString, dataKeyName) => `/api/reports/monthly/${dateString}/apo/${dataKeyName}-details`;
export const GET_TOTAL_SALES_REPORT_DETAIL_API      = (dateString, dataKeyName) => `/api/reports/monthly/${dateString}/totalSales/${dataKeyName}-details`;

/** ================================
 * 📌 PJ CA 營運報表
 *  ================================
 */
export const GET_REPORT_PJ_EXCEL_API         = `/api/reports-export/pj-output.xlsx`;
export const GET_REPORT_CA_EXCEL_API         = `/api/reports-export/ca-output.xlsx`;
export const GET_REPORT_PJ_API               = `/api/reports/pj/`;
export const GET_REPORT_CA_API               = `/api/reports/ca/`;
export const GET_REPORT_KPI_API              = `/api/reports/kpi/`;
export const POST_REPORT_HC_GOAL_DATE_API    = (taeget) => `/api/reports/kpi-healthcare-target-setting/${taeget}/`;
export const POST_REPORT_GOAL_DATE_API       = (taeget) => `/api/reports/kpi-target-setting/${taeget}/`;
export const GET_REPORT_MEMBERSHIP_API       = `/api/reports/membership/`;
export const GET_REPORT_SERVICE_API          = `/api/reports/service/`;
export const GET_REPORT_GUEST_PRODUCTION_API = `/api/reports/guest-production/`;
export const GET_REPORT_SALES_API            = `/api/reports/not-membership/`;
export const GET_REPORT_EMPLOYEE_API         = `/api/reports/employee/`;

/** ================================
 * 📌 簡訊相關
 *  ================================
 */
export const GET_SMS_OVERVIEW_OPTIONS_API = `/api/sms/overview/options/`;
export const POST_SMS_OVERVIEW_API        = `/api/sms/overview/`;
export const GET_SMS_SMSID_API            = (smsID) => `/api/sms/${smsID}/`;
export const POST_SMS_API                 = `/api/sms/`;
export const POST_SMS_TEMPORARIES_API     = `/api/sms/temporaries/`;
export const POST_SMS_SMSID_CANCEL_API    = (smsID) => `/api/sms/${smsID}/cancel/`;
export const GET_SMS_POINT_API            = `/api/sms/point/`;

/** ================================
 * 📌 排行榜
 *  ================================
 */
export const GET_MEASURE_LEADERBOARD_OPTION_API                  = `/api/measure/leaderboard/option/`;
export const GET_MEASURE_LEADERBOARD_OVERVIEW_API                = `/api/measure/leaderboard/overview/`;
export const POST_MEASURE_LEADERBOARD_PDF_API                    = (leaderboardType) => `/api/measure/leaderboard/leaderboardtpye/${leaderboardType}/`;
export const GET_MEASURE_LEADERBOARD_ZIP_CLUBCODE_TARGETDATE_API = (clubCode, targetDate) => `/api/measure/leaderboard/${clubCode}/${targetDate}/savezip.zip`;
export const GET_MEASURE_LEADERBOARD_MEMBERID_API                = (memberID) => `/api/measure/leaderboard/member/${memberID}`;


/** ================================
 * 📌 左側Menu選單
 *  ================================
 */
export const GET_ME_MENUS_API = '/api/me/menus/';

/** ================================
 * 📌 發票相關
 *  ================================
 */
export const GET_INVOICES_OPTIONS_API     = `/api/invoices/options/`;
export const GET_INVOICES_TAX_COMPANY_API = `/api/invoices/query-tax-company/`;
export const GET_INVOICES_MEMBER_API = (memberID) => `/api/invoices/member/${memberID}/`;

/** ================================
 * 📌 InvoiceAllowance 三聯式發票折讓（triplicate-uniform）
 *  ================================
 */
export const GET_INVOICE_ALLOWANCE_TRIPLICATE_UNIFORM_OVERVIEW_OPTIONS_API = `/api/invoice-allowance/triplicate-uniform/overview/options/`;
export const POST_INVOICE_ALLOWANCE_TRIPLICATE_UNIFORM_OVERVIEW_API          = `/api/invoice-allowance/triplicate-uniform/overview/`;

/**
 * 三聯折讓證明單上傳（multipart）
 * 後端：InvoiceTriplicateUniformController.Upload — POST api/invoice-allowance/triplicate-uniform/{orderID}/returns/{orderReturnID}/upload，IFormFile 參數名為 file
 * TODO：若後端路由、參數名或驗證規則變更，請與後端確認後同步調整
 */
export const POST_INVOICE_ALLOWANCE_TRIPLICATE_UNIFORM_RETURN_UPLOAD_API = (orderID, orderReturnID) =>
	`/api/invoice-allowance/triplicate-uniform/${orderID}/returns/${orderReturnID}/upload`;

/**
 * 已上傳三聯折讓證明書下載（檔案串流，非標準 ResponseModel JSON）
 * 後端：InvoiceTriplicateUniformController.GetConfirmPdf — GET /pdf/orders/{orderID}/returns/{orderReturnID}/doc/triplicate-uniform-confirm.{extension}
 * TODO：請確認實際儲存副檔名（目前儲存流程多為 .pdf）與 Content-Type 是否與前端下載方式（例如 useAjax.getPDF）相容
 */
export const GET_ORDER_RETURN_DOC_TRIPLICATE_UNIFORM_CONFIRM_API = (orderID, orderReturnID, extension = "pdf") =>
	`/pdf/orders/${orderID}/returns/${orderReturnID}/doc/triplicate-uniform-confirm.${extension}`;

/** ================================
 * 📌 Inbody雲端列印
 *  ================================
 */
export const POST_PRINT_API = `/api/print/`;

/** ================================
 * 📌 贈品兌換
 *  ================================
 */
export const GET_POINTS_REWARDS_ORDERS_OVERVIEW_OPTIONS_API     = `/api/points/redeem-orders/overview/options/`;
export const GET_POINTS_REWARDS_ORDERS_OVERVIEW_API             = `/api/points/redeem-orders/overview/`;
export const GET_POINTS_REWARDS_ORDERS_REMEEMITEMID_RECORDS_API = (redeemItemID) => `/api/points/redeem-orders/${redeemItemID}/records/`;


/** ================================
 * 📌 健康產品與一般商品相關
 *  ================================
 */
export const GET_PRODUCT_SEARCH_SALE_OPTIONS_API = `/api/products/search-sale-options/`;
export const GET_PRODUCT_SEARCH_SALE_SINGLE_API  = `/api/products/search-sale-single/`;
export const GET_PRODUCT_SALE_OPTIONS_API        = `/api/products/sale-options/`;
export const GET_CYCLE_PURCHASE_PRODUCTS_API     = `/api/products/cycle-purchase/`;


/** ================================
 * 📌 健康產品與商品的“贈點”相關
 *  ================================
 */
export const GET_POINTS_REWARDS_OVERVIEW_OPTIONS_API                          = `/api/points/rewards/overview/options/`;
export const GET_POINTS_REWARDS_OVERVIEW_API                                  = `/api/points/rewards/overview/`;
export const GET_POINTS_REWARDS_REWARDID_RECORDS_API                          = (rewardID) => `/api/points/rewards/${rewardID}/records/`;
export const DELETE_PONITS_REWARDS_REWARDID_API                               = (rewardID) => `/api/points/rewards/${rewardID}`;
export const GET_POINTS_REWARDS_REWARDID_ACTIVITY_ACTIVITYID_REDEEM_CART_API  = (rewardID, activityID) => `/api/points/rewards/${rewardID}/activity/${activityID}/redeem-cart/`;
export const POST_POINTS_REWARDS_REWARDID_ACTIVITY_ACTIVITYID_REDEEM_CART_API = GET_POINTS_REWARDS_REWARDID_ACTIVITY_ACTIVITYID_REDEEM_CART_API;
export const POST_POINTS_REWARDS_REWARDID_ACTIVITY_ACTIVITYID_UNREDEEMED_API  = (rewardID, activityID) => `/api/points/rewards/${rewardID}/activity/${activityID}/un-redeem/`;
export const POST_POINTS_REWARDS_REWARDID_ACCUMULATE_API                      = (rewardID) => `/api/points/rewards/${rewardID}/accumulate/`;
export const POST_POINTS_REWARDS_REWARDID_REDEEM_STATUS_REDEEMRECORDID_API    = (rewardID, redeemRecordID) => `/api/points/rewards/${rewardID}/redeem-status/${redeemRecordID}/`;
export const GET_POINTS_REDEEM_ITEMS_REDEEMITEMID_API                         = (redeemItemID) => `/api/points/redeem-items/${redeemItemID}/`;
export const GET_POINTS_REWARDS_EXPORT_API                                    = `/api/points/rewards/export`;
export const GET_POINTS_REDEEM_ORDERS_ALL_RECORDS_API                         = `/api/points/redeem-orders/all-records/`;
export const POST_POINTS_REDEEM_ORDERS_SYNC_TASKS_API                         = `/api/points/redeem-orders/sync-tasks/`;

/** ================================
 * 📌 DeviceOrder 智能系統
 *  ================================
 */
export const GET_DEVICE_ORDER_OPTIONS_API    = `/api/device-orders/options/`;
export const GET_DEVICE_ORDER_API            = (deviceOrdersID) => `/api/device-orders/${deviceOrdersID}/`;
export const DELETE_DEVICE_ORDER_API         = (deviceOrdersID) => `/api/device-orders/${deviceOrdersID}/`;
export const GET_DEVICE_ORDER_MEMBER_API     = (memberID) => `/api/device-orders/member/${memberID}/default/`;
export const POST_DEVICE_ORDERS_OVERVIEW_API = `/api/device-orders/overview/`;
export const POST_DEVICE_ORDERS_EXPORT_OVERVIEW_API = `/api/device-orders-export/overview/`;
export const POST_DEVICE_ORDERS_API          = `/api/device-orders/`;
export const POST_DEVICE_ORDERS_RANGE_FEE_API    = `/api/device-orders/range-fee/`;

export const GET_DEVICE_ORDERS_EFFECTION_OPTIONS_API                     = `/api/device-orders/effection/options/`;
export const GET_DEVICE_ORDERS_EFFECTION_DEVICEORDERSID_API              = (deviceOrdersID) => `/api/device-orders/effection/${deviceOrdersID}`;
export const POST_DEVICE_ORDERS_EFFECTION_DEVICEORDERSID_API             = GET_DEVICE_ORDERS_EFFECTION_DEVICEORDERSID_API;
export const POST_DEVICE_ORDERS_EFFECTION_DEVICEORDERSID_EFFECTID_API    = (deviceOrdersID, effectID) => `/api/device-orders/effection/${deviceOrdersID}/${effectID}/`;
export const DELETEW_DEVICE_ORDERS_EFFECTION_DEVICEORDERSID_EFFECTID_API = POST_DEVICE_ORDERS_EFFECTION_DEVICEORDERSID_EFFECTID_API;
export const DELETE_DEVICE_ORDERS_EFFECTION_EFFECTID_API = (effectID, employeeID) => `/api/device-orders/effection/${effectID}?employeeID=${employeeID}`;

export const POST_DEVICE_ORDER_DETAIL_ORDERS_API            = (memberID) => `/api/device-order-deatil/${memberID}/orders`;
export const POST_MEMBER_DEVICE_ORDER_LIST_API              = `/api/members/device-order/list`;
export const GET_MEMBER_DEVICE_SUBSCRIPTION_ORDER_CHECK_API = (memberID) => `/api/members/${memberID}/device-subscription/order-check/`;

export const GET_MEMBER_DISCARD_RECORD_OPTIONS   = `/api/member-discard-record/options/`;
export const POST_MEMBER_DISCARD_RECORD_STOP_SMS = '/api/member-discard-record/stop-sms/';

/** ================================
 *  Pos System 收銀系統
 */

export const GET_POS_OPTIONS_API= `/api/pos/options/`;
// GET_POS_PRODUCTS_SKU_API 有更好的命名嗎?
export const GET_POS_PRODUCTS_SKU_API = `/api/pos/products/sku/`;
export const GET_POS_MEMBER_INFO_API= `/api/pos/member-info/`;
export const POST_POS_ORDER_API= `/api/pos/order/`;
export const POST_POS_ITEMS_CAMPAIGN_API= `/api/pos/items/campaign/`;

/** ================================
 *  PartnerVoucher 合作夥伴兌換序號
 */

export const POST_PARTNER_VOUCHER_VALIDATE_API = `/api/partner-vouchers/validate/`;
